import { Link } from '@tanstack/react-router'
import { SignupForm } from './components/SignupForm'
import { OTPForm } from './components/OTPForm'
import { useSignupViewModel } from './hooks/useSignupViewModel'

export function SignupPage() {
  const vm = useSignupViewModel()

  // Same hand-off as /login, in the other direction: an already-registered email
  // and the pending `redirect` both travel to the sign-in page.
  const loginSearch = {
    ...(vm.email ? { email: vm.email } : {}),
    ...(vm.redirect ? { redirect: vm.redirect } : {}),
  }

  return (
    <div className='absolute inset-0 flex items-center justify-center px-4'>
      {vm.step === 'email' ? (
        <SignupForm
          firstName={vm.firstName}
          onFirstNameChange={vm.setFirstName}
          lastName={vm.lastName}
          onLastNameChange={vm.setLastName}
          email={vm.email}
          onEmailChange={vm.setEmail}
          acceptedTerms={vm.acceptedTerms}
          onAcceptedTermsChange={vm.setAcceptedTerms}
          emailMarketingConsent={vm.emailMarketingConsent}
          onEmailMarketingConsentChange={vm.setEmailMarketingConsent}
          onSubmit={vm.handleEmailSubmit}
          isLoading={vm.isRequestingCode}
          error={vm.error}
          errorAction={
            vm.errorKind === 'email-taken' ? (
              <Link
                to='/login'
                search={loginSearch}
                className='text-sm font-semibold text-red-800 underline hover:no-underline'
              >
                Sign in instead
              </Link>
            ) : undefined
          }
          footer={
            <p className='text-center text-sm text-muted-foreground'>
              Already have an account?{' '}
              <Link
                to='/login'
                search={loginSearch}
                className='font-medium text-primary hover:underline'
              >
                Sign in
              </Link>
            </p>
          }
        />
      ) : (
        <OTPForm
          otp={vm.otp}
          onOtpChange={vm.setOtp}
          onSubmit={vm.handleVerifyCode}
          onResend={vm.handleResendCode}
          onBack={vm.handleBackToEmail}
          isLoading={vm.isVerifying}
          isResending={vm.isResending}
          error={vm.error}
          notice={vm.notice}
          cooldown={vm.cooldownRemaining}
          email={vm.email}
        />
      )}
    </div>
  )
}
